
define('require-css/css!js-css/figcaption-toggles',[],function(){});
